import React from 'react';
import { Container } from '@mui/material';
import Grid from '@mui/material/Grid'; 
import { Link } from "react-router-dom";


const UiDemo = (props) => {
	return (
		<Container>
			<Grid Container >
				<Grid>
					<a href={"/ui/main"}><h3>Mainwrapper</h3></a>
				</Grid>
				<Grid>
				<a href={"/ui/dashboard"}><h3>Dashboard</h3></a>
				</Grid>
			</Grid>
			
		 </Container>

	);
};

export default UiDemo;
